import SiteBase from "./siteBase";

const PatientSite = () => {
  return (
    <SiteBase patientSite={true}/>
  )
};

export default PatientSite;